/**
 * Created by Rodrigo Quesada on 25/04/17.
 */
import {Model, ModelMixin} from '../../common/model.class';
import {LocalDateInterval} from '../../common/values/local-date-interval.class';

//region Other Classes
export class Entry {

    name?: string;
    duration?: LocalDateInterval;

    constructor(jsonData: any = {}) {
        if (jsonData.duration) jsonData.duration = new LocalDateInterval(jsonData.duration);
        Object.assign(this, jsonData);
    }
}
//endregion

export class GapInfo extends ModelMixin() implements Model<GapInfo> {

    TYPE = GapInfo;

    workEntries: Array<Entry>;
    militaryEntry?: Entry;
    gaps: Array<LocalDateInterval>;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.workEntries) jsonData.workEntries = jsonData.workEntries.map(it => new Entry(it));
        if (jsonData.militaryEntry) jsonData.militaryEntry = new Entry(jsonData.militaryEntry);
        if (jsonData.gaps) jsonData.gaps = jsonData.gaps.map(it => new LocalDateInterval(it));
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/work/history/gap-info.model.ts